import { ProductImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/productImpression.trackingInfo";

import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";
import {
    GoogleAnalyticsProduct,
    getGoogleAnalyticsProduct
} from "./GoogleAnalyticsProduct";

export interface GoogleAnalyticsProductImpression
    extends GoogleAnalyticsMinimumDataset {
    ecommerce: {
        click: {
            actionField?: {
                list?: string;
                listTitle?: string;
                placement?: number;
            };
            products: GoogleAnalyticsProduct[];
        };
    };
}

const getGoogleAnalyticsProductClickImpression = (
    data: TypedAnalyticsEvent<ProductImpressionTrackingInfo>
): GoogleAnalyticsProductImpression => {
    return {
        event: GoogleAnalyticsEvents.ProductClick,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        ecommerce: {
            click: {
                actionField: {
                    list: data.payload.eventData.list,
                    listTitle: data.payload.eventData.listTitle,
                    placement: data.payload.eventData.placement
                },
                products: [getGoogleAnalyticsProduct(data.payload.eventData)]
            }
        }
    };
};

export { getGoogleAnalyticsProductClickImpression };
